import { Configuration, LogLevel } from "@azure/msal-browser";

export const b2cPolicies = {
    names: {
        signUpSignIn: process.env.REACT_APP_B2C_POLICY_SIGN_UP_SIGN_IN,
        forgotPassword: process.env.REACT_APP_B2C_POLICY_PASSWORD_RESET,
        editProfile: process.env.REACT_APP_B2C_POLICY_PROFILE_EDITING,
    },
    authorities: {
        signUpSignIn: {
            authority: 'https://'+process.env.REACT_APP_TENANT_NAME+'.b2clogin.com/'+process.env.REACT_APP_TENANT_NAME+'.onmicrosoft.com/'+process.env.REACT_APP_B2C_POLICY_SIGN_UP_SIGN_IN,
        },
        forgotPassword: {
            authority: 'https://'+process.env.REACT_APP_TENANT_NAME+'.b2clogin.com/'+process.env.REACT_APP_TENANT_NAME+'.onmicrosoft.com/'+process.env.REACT_APP_B2C_POLICY_PASSWORD_RESET,
        },
        editProfile: {
            authority: 'https://'+process.env.REACT_APP_TENANT_NAME+'.b2clogin.com/'+process.env.REACT_APP_TENANT_NAME+'.onmicrosoft.com/'+process.env.REACT_APP_B2C_POLICY_PROFILE_EDITING,
        },
    },
    authorityDomain: process.env.REACT_APP_TENANT_NAME+'.b2clogin.com',
};

export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const protectedResources = {
    apiTodoList: {
        endpoint: process.env.REACT_APP_BACKEND_URL,
        scopes: {
            read: ['https://estudiogomezplateroai.onmicrosoft.com/image-generation/api/images.save'],
            write: ['https://estudiogomezplateroai.onmicrosoft.com/image-generation/api/images.upload'],
        },
    },
};

export const loginRequest = {
    scopes: [...protectedResources.apiTodoList.scopes.read, ...protectedResources.apiTodoList.scopes.write],
};